import get from 'lodash/get'
import {call, put, select, takeLatest} from 'redux-saga/effects'

import {onStatus} from '../api/helpers'
import * as productActions from '../actions/product'
import * as productApi from '../api/product'
import * as reviewsActions from '../actions/reviews'
import * as reviewsApi from '../api/reviews'
import * as reviewsSelectors from '../store/reviews'

export function* displayFeaturedReviewsWorker({payload: {productId}}) {
  try {
    if (!productId) {
      throw new Error('Missing product ID')
    }

    const response = yield call(reviewsApi.getFeaturedReviews, productId)
    const payload = onStatus({
      OK: ({json}) => json?.response,
      DEFAULT: () => {
        throw new Error('Unable to fetch featured reviews')
      },
    })(response)

    if (get(payload, 'reviews', []).length === 0) {
      throw new Error('No featured reviews available')
    }
    yield put(reviewsActions.featuredReviewsOk(payload))
  } catch (err) {
    yield put(reviewsActions.featuredReviewsNotOk(err.toString()))
  }
}

export function* displayFeaturedReviewsSaga() {
  yield takeLatest(reviewsActions.DISPLAY_FEATURED_REVIEWS, displayFeaturedReviewsWorker)
}

export function* displayAllReviewsWorker({payload: {productSlug}}) {
  if (!productSlug) {
    yield put(reviewsActions.productReviewsNotOk('Missing product slug'))
    return
  }

  let productId = null

  try {
    const productSetResponse = yield call(productApi.getProductSet, productSlug)
    const productSetPayload = onStatus({
      OK: ({json}) => json,
      DEFAULT: () => {
        throw new Error('Failed fetching product set information')
      },
    })(productSetResponse)
    productId = productSetPayload.id
    yield put(productActions.displayProductAction(productSetPayload.urlSlug))
    yield put(productActions.productOk(productSetPayload))
  } catch (err) {
    yield put(productActions.productNotOk(err.toString()))
  }

  try {
    const reviewsResponse = yield call(reviewsApi.getAllReviews, productId)
    const reviewsPayload = onStatus({
      OK: ({json}) => json,
      DEFAULT: () => {
        throw new Error('Failed fetching all reviews')
      },
    })(reviewsResponse)
    yield put(reviewsActions.productReviewsOk(reviewsPayload))
    yield put(reviewsActions.productReviewsPaginationOk(reviewsPayload.reviews))
  } catch (err) {
    yield put(reviewsActions.productReviewsNotOk(err.toString()))
  }
}

export function* displayAllReviewsSaga() {
  yield takeLatest(reviewsActions.DISPLAY_ALL_REVIEWS, displayAllReviewsWorker)
}

export function* filterReviewsWorker() {
  const productReviews = yield select(reviewsSelectors.productReviewsArray)
  const eventFilterIsApplied = yield select(reviewsSelectors.eventFilterIsApplied)
  const eventFilter = yield select(reviewsSelectors.currentEventFilter)
  const scoreFilterIsApplied = yield select(reviewsSelectors.scoreFilterIsApplied)
  const scoreFilter = yield select(reviewsSelectors.currentScoreFilter)
  let filteredReviews = productReviews

  if (eventFilterIsApplied) {
    filteredReviews = filteredReviews.filter((review) => review.event === eventFilter)
  }
  if (scoreFilterIsApplied) {
    filteredReviews = filteredReviews.filter((review) => review.score === scoreFilter)
  }

  yield put(reviewsActions.productReviewsPaginationOk(filteredReviews))
}

export function* filterReviewsSaga() {
  yield takeLatest(
    [reviewsActions.FILTER_REVIEWS_BY_SCORE, reviewsActions.FILTER_REVIEWS_BY_EVENT],
    filterReviewsWorker,
  )
}
